import InfoCountMixin from '@/mixins/InfoCountMixin'

export default {
  props: {
    count: Number,
  },
  mixins: [InfoCountMixin],
}
